//---------------------------------------------------------------------------------------------
//hover
//---------------------------------------------------------------------------------------------

$(document).ready(function () {
  if (location.hash) {
    $(location.hash).show();
  }
});

function rollOverFn() {
  var imgNum = document.getElementsByTagName("img");
  var inputNum = document.getElementsByTagName("input");
  overNum = new Array;
  for (i = 0; i < imgNum.length; i++) {
    overNum[i] = imgNum[i];
  }
  for (i = 0; i < inputNum.length; i++) {
    overNum[i + imgNum.length] = inputNum[i];
  }
  for (i = 0; i < overNum.length; i++) {
    if (overNum[i].className.indexOf("js-rollOver") != -1) {
      overNum[i].overimg = new Image();
      if (overNum[i].className.indexOf(":") != -1) {
        Replace = overNum[i].className.split(":");
        Replace = Replace[1].split(" ");
        overNum[i].overimg.src = Replace[0];
      } else {
        Replace = overNum[i].src.length;
        overNum[i].overimg.src = overNum[i].src.substring(0, Replace - 4) + "_on" + overNum[i].src.substring(Replace - 4, Replace);
      }
      overNum[i].setAttribute("out", overNum[i].src);
      overNum[i].onmouseover = new Function('this.src=this.overimg.src;');
      overNum[i].onmouseout = new Function('this.src=this.getAttribute("out");');
    }
  }
}
window.onload = rollOverFn;

//---------------------------------------------------------------------------------------------
//autoHeight
//---------------------------------------------------------------------------------------------
(function ($) {
  $.fn.autoHeight = function (options) {
    var op = $.extend({

      column: 0,
      clear: 0,
      height: 'minHeight',
      reset: '',
      descend: function descend(a, b) {
        return b - a;
      }
    }, options || {}); 
    var self = $(this);
    var n = 0,
      hMax,
      hList = new Array(),
      hListLine = new Array();
    hListLine[n] = 0;


    self.each(function (i) {
      if (op.reset == 'reset') {
        $(this).removeAttr('style');
      }
      var h = $(this).height();
      hList[i] = h;
      if (op.column > 1) {
        if (h > hListLine[n]) {
          hListLine[n] = h;
        }
        if ((i > 0) && (((i + 1) % op.column) == 0)) {
          n++;
          hListLine[n] = 0;
        };
      }
    });

    hList = hList.sort(op.descend);
    hMax = hList[0];


    var ie6 = typeof window.addEventListener == "undefined" && typeof document.documentElement.style.maxHeight == "undefined";
    if (op.column > 1) {
      for (var j = 0; j < hListLine.length; j++) {
        for (var k = 0; k < op.column; k++) {
          if (ie6) {
            self.eq(j * op.column + k).height(hListLine[j]);
          } else {
            self.eq(j * op.column + k).css(op.height, hListLine[j]);
          }
          if (k == 0 && op.clear != 0) {
            self.eq(j * op.column + k).css('clear', 'both');
          }
        }
      }
    } else {
      if (ie6) {
        self.height(hMax);
      } else {
        self.css(op.height, hMax);
      }
    }
  };
})(jQuery);


$(function () {
  //scroll
  $('.pagetop a[href^="#"]').click(function () {
    var speed = 900;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({
      scrollTop: position
    }, speed, "swing");
    return false;
  });


  /*----------------------------
  common
  ----------------------------*/

  $(".header .headerCont .search dl dt input,.sideContents .codeJump dl dt input,.footer .searchArea .search .input input").val("");
  $(".header .headerCont .search dl dt input,.sideContents .codeJump dl dt input,.footer .searchArea .search .input input").focus(function () {
    $(this).addClass("on");
  }).blur(function () {
    if ($(this).val() == "") {
      $(this).removeClass("on");
    }
  });


  $('.menu ul > li').hover(function () {
    $(this).addClass("menuOn");
    $(".navCont", this).addClass("current");
    $(this).not(":animated").find(".menuInner").show();
  }, function () {
    $(this).removeClass("menuOn");
    $(this).not(":animated").find(".menuInner").hide();
    $(".navCont", this).removeClass("current");
  });

  $('.menu ul li.nav1 .firstLevel > li').hover(function () {
    $(this).not(":animated").find(".secondLevel").show().prev().addClass("on");
  }, function () {
    $(this).not(":animated").find(".secondLevel").hide().prev().removeClass("on");
  });



  $(".categorySearch >li > span").click(function () {
    $(this).next().slideToggle("fast");
    $(this).toggleClass("on");
  })


  $(".localNavi a").click(function () {
    var acLink = $(this).attr("href");
    $(".localNavi a").removeClass("current");
    $(".localNavi a[href=" + acLink + "]").addClass("current");
    $(".productContents").removeClass("on");
    $($(this).attr("href")).addClass("on");
    return false;
  })


  //pagetop
  $(window).scroll(function () {
    scrollHeight = $(document).height();
    scrollPosition = $(window).height() + $(window).scrollTop();
    footHeight = $("footer").height();
    scrollTop = $(window).scrollTop();
    if (scrollTop > 500) {
      $(".pagetop,.footBtn").fadeIn();
    } else {
      $(".pagetop,.footBtn").fadeOut();
    }
    if (scrollHeight - scrollPosition < footHeight) {
      $(".pagetop").css({
        "position": "absolute",
        "bottom": footHeight + 75
      });
      $(".footBtn").css({
        "position": "absolute",
        "bottom": footHeight + 26
      });
    } else {
      $(".pagetop").css({
        "position": "fixed",
        "bottom": "58px"
      });
      $(".footBtn").css({
        "position": "fixed",
        "bottom": "0"
      });
    }
  });


  /*----------------------------
  parts
  ----------------------------*/

  $(".seriesArea").each(function () {
    $(".seriesArea li .text").autoHeight({
      column: 3,
      clear: 1
    });
    $(".seriesArea li").autoHeight({
      column: 3,
      clear: 1
    });
    $(".seriesArea li h3").autoHeight({
      column: 3,
      clear: 1
    });
    $(".seriesArea li figure").autoHeight({
      column: 3,
      clear: 1
    });
  });


  $(".boxStyle").each(function () {
    $(".boxStyle .inner").autoHeight({
      column: 2,
      clear: 1
    });
  });


  $(".buttonColumn").each(function () {
    $(".buttonColumn li a").autoHeight({
      column: 3,
      clear: 1
    });
  });


  /*----------------------------
  toggle
  ----------------------------*/
  $(".toggleArea .title").click(function () {
    $(this).toggleClass("on").next().slideToggle("fast");
  })



  /*----------------------------
  slider
  ----------------------------*/
  if (document.getElementById("js-slider") != null) {

    $('#js-slider .visual ul').cycle({
      //fx:'scrollDown',
      speed: 300,
      timeout: 4000,
      pager: '.thumbNav',
      pagerEvent: 'mouseover',
      prev: '#prev',
      next: '#next',

      pagerAnchorBuilder: function (idx, slide) {
        // return selector string for existing anchor
        return '.thumbNav li:eq(' + idx + ')';
      },
      pauseOnPagerHover: true
    });


    $('#js-slider .thumbNav li a').click(function (event) {
      event.stopPropagation();
    });
  }
  
});